import React from 'react'
import { Link } from 'react-router-dom'
import { getOptimizedImageUrl } from '../lib/cms'

export default function DestinationCard({ destination }) {
  const imageUrl = Array.isArray(destination.hero_billede)
    ? destination.hero_billede[0]
    : destination.hero_billede

  const slug = destination.url_slug || destination.slug?._ || destination.id

  return (
    <Link
      to={`/destinationer/${slug}`}
      className="group relative h-80 rounded-2xl overflow-hidden border border-slate-800 bg-slate-900 shadow-xl flex flex-col justify-end p-6 hover:border-cyan-500/50 transition-all duration-300"
    >
      {/* Background Image */}
      <img
        src={getOptimizedImageUrl(imageUrl, 800, 80)}
        alt={destination.destinationsnavn}
        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent" />

      {/* Country Tag */}
      {destination.land && (
        <span className="absolute top-4 left-4 bg-slate-950/80 backdrop-blur-md text-cyan-300 text-xs font-semibold px-3 py-1 rounded-full border border-slate-700">
          <i className="fa-solid fa-earth-europe mr-1.5" aria-hidden="true" />
          {destination.land}
        </span>
      )}

      {/* Content */}
      <div className="relative z-10 space-y-2">
        <h3 className="font-heading font-extrabold text-2xl text-white group-hover:text-cyan-300 transition-colors">
          {destination.destinationsnavn}
        </h3>
        <p className="text-slate-300 text-sm line-clamp-2 leading-relaxed">
          {destination.kort_beskrivelse}
        </p>

        <div className="pt-2 flex items-center gap-2 text-xs font-semibold text-cyan-400 group-hover:translate-x-1 transition-transform">
          <span>Udforsk destination</span>
          <i className="fa-solid fa-arrow-right" aria-hidden="true" />
        </div>
      </div>
    </Link>
  )
}
